import { LoadableAfterPaint } from '@confluence/loadable';

export const HubSettingsEntryButton = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HubSettingsEntryButton" */ '../src/hub-settings/HubSettingsEntryButton.tsx'
			)
		).HubSettingsEntryButton,
});

export { HubSettingsEntryButtonAppearance } from '../src/hub-settings/HubSettingsEntryButton.tsx';
